import { OrganizerRating } from 'components/ReviewAudit/PublicRatings'
import React from "react"
import { Link } from "react-router-dom"
import moment from "moment-timezone"
import { capitalize } from "lodash"
import { getOrganizerDisplayName } from "./ProfileInfo/profileDisplay"
import OrganizerActions from "./OrganizerActions"

export const ORGANIZER_TIMEZONE = "Europe/Bucharest"
const text = value => typeof value === "string" ? value.trim() : ""
const contact = (account, field) => {
  const primary = text(account.organizerInfo?.[field])
  const value = primary || text(account[field])
  const valid = field === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) : /^\+?[\d\s().-]{5,}$/.test(value)
  const href = field === "email" ? `mailto:${encodeURIComponent(value)}` : `tel:${value.replace(/[^+\d]/g, "")}`
  return <div>{value ? <>
    {valid ? <a href={href}>{value}</a> : <span>{value}</span>}
    {!primary && <small className="d-block text-muted">Account {field}</small>}
  </> : <span className="text-muted">{capitalize(field)} not specified</span>}</div>
}
const listColumns = (organizerListSearch = "") => {
  const profilePath = account => ({ pathname: `/accounts/organizers/${account.id}`, state: { organizerListSearch } })
  return [
    { dataField: "identity", text: "Organizer", formatter: (_, account) => <div className="organizer-cell">
      <Link to={profilePath(account)} className="club-list-name">{getOrganizerDisplayName(account)}</Link>
      <OrganizerRating id={account.id || account._id} />
      <span className="text-muted">#{account.userId ?? "—"} · {capitalize(account.role)} account</span>
    </div> },
    { dataField: "contact", text: "Contact", formatter: (_, account) => <div className="organizer-cell organizer-contact">
      {contact(account, "email")}{contact(account, "phone")}
    </div> },
    { dataField: "location", text: "Organizer location", formatter: (_, account) => <span>
      {[account.organizerInfo?.location?.city, account.organizerInfo?.location?.country].filter(Boolean).join(", ")
        || account.organizerInfo?.location?.name || "Not specified"}
    </span> },
    { dataField: "clubs", text: "Assigned clubs", formatter: (_, account) => <div className="organizer-cell">
      {account.clubsUnavailable ? <span className="text-muted">Clubs unavailable</span> : <>
        <span>{account.resolvedClubs?.length || 0} {(account.resolvedClubs?.length || 0) === 1 ? "club" : "clubs"}</span>
        {(account.resolvedClubs || []).slice(0, 2).map(club => <Link key={club.id} to={`/accounts/clubs/${club.id}`}>{club.clubName || "Unnamed club"}</Link>)}
        {account.resolvedClubs?.length > 2 && <Link to={profilePath(account)}>View all {account.resolvedClubs.length} clubs</Link>}
        {account.missingClubCount > 0 && <small className="text-muted">{account.missingClubCount} unavailable {account.missingClubCount === 1 ? "assignment" : "assignments"}</small>}
      </>}
    </div> },
    { dataField: "createdAt", text: "Status / Account created", formatter: (value, account) => {
      const date = value ? moment(value).tz(ORGANIZER_TIMEZONE) : null
      const color = { activated: "success", pending: "info", blocked: "warning", deleted: "secondary" }[account.status] || "secondary"
      return <div className="organizer-cell"><span className={`badge badge-${color}`}>{capitalize(account.status) || "Not specified"}</span>
        {date?.isValid() ? <time dateTime={date.toISOString()} title={`${date.format("YYYY-MM-DD HH:mm:ss Z")} (${ORGANIZER_TIMEZONE})`}>
          {date.format("D MMM YYYY")}<small className="d-block text-muted">{date.format("HH:mm")}</small>
        </time> : <span className="text-muted">Date not specified</span>}
      </div>
    } },
    { dataField: "actions", text: "Actions", formatter: (_, account) => <OrganizerActions account={account} profilePath={profilePath(account)} name={getOrganizerDisplayName(account)} /> },
  ]
}
export default listColumns
